import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{staticClass:"white--text",attrs:{"loading":_vm.loading,"dense":"","color":"green","dark":"","small":"","tile":""},on:{"click":_vm.handleUpload}},[_c(VIcon,{attrs:{"small":"","left":""}},[_vm._v("mdi-microsoft-excel")]),_vm._v(" Seleccionar archivo ")],1),_c('input',{ref:"excel-upload-input",staticClass:"excel-upload-input",attrs:{"type":"file","accept":".xlsx, .xls","small":""},on:{"change":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }